import { TextButton } from 'cdk-radial';
import { useIntl } from 'react-intl';
import { labels } from 'pages/AuthorizePaymentPage/messages';
import { ResetButtonType } from 'pages/AuthorizePaymentPage/types';

export const ResetButton = ({
  setReset,
  isEdit,
  setIsEdit
}: ResetButtonType): React.JSX.Element => {
  const intl = useIntl();
  return (
    <TextButton
      text={intl.formatMessage(labels.resetLabel)}
      id="reset-btn"
      dataTestId="reset-btn"
      onClick={() => {
        setReset();
        setIsEdit(!isEdit);
      }}
    />
  );
};
